import ReferralsIndexContainer from './ReferralsIndexContainer';
export default ReferralsIndexContainer;